import {AccountType, SubscriptionType} from "../components/constants/securspace-constants";
import {
  getSuperAdminUserTypes,
  getAdminUserTypes,
  getOwnerUserTypes,
  getBuyerUserTypes,
  getSupplierUserTypes,
  getGateManagerUserTypes
} from "../util/AccountUtils";
import _ from 'underscore'


export default class AccessControlBuilder {
  _userTypes: string[] = [];
  _accountTypes: string[] = [];
  _subscriptionTypes: string[] = [];

  build = () => {
    return {
      userTypes: this._userTypes,
      accountTypes: this._accountTypes,
      subscriptionTypes: this._subscriptionTypes
    }
  }

  allowUserType = (userType: string) => {
    if (!_.contains(this._userTypes, userType)) {
      this._userTypes.push(userType);
    }

    return this;
  }

  allowUserTypes = (userTypeArray: string[]) => {
    userTypeArray?.forEach(userType => {
      this.allowUserType(userType);
    });

    return this;
  }

  allowAccountType = (accountType: string) => {
    if (!_.contains(this._accountTypes, accountType)) {
      this._accountTypes.push(accountType);
    }

    return this;
  }

  allowSubscriptionType = (subscriptionType: string) => {
    if (!_.contains(this._subscriptionTypes, subscriptionType)) {
      this._subscriptionTypes.push(subscriptionType);
    }

    return this;
  }

  allowAllOwners = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getOwnerUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    this.allowAccountType(AccountType.BUYER);
    this.allowAllSubscriptionTypes();
    return this;
  }

  allowAllBuyer = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getBuyerUserTypes());
    this.allowAccountType(AccountType.BUYER);
    this.allowAllSubscriptionTypes();
    return this;
  }

  allowBuyerOwner = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getOwnerUserTypes());
    this.allowAccountType(AccountType.BUYER);
    this.allowAllSubscriptionTypes();
    return this;
  }

  allowAllGmsUsers = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getSupplierUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    this.allowGmsSubscriptionTypes();
    return this;
  }

  allowAllSupplierOwner = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getOwnerUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    this.allowAllSubscriptionTypes();
    return this;
  }

  allowGateManager = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getGateManagerUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    this.allowGmsSubscriptionTypes();
    return this;
  }

  allowMarketplaceOnlySupplier = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getOwnerUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    this.allowSubscriptionType(SubscriptionType.MARKETPLACE_ONLY);
    return this;
  }

  allowGmsProOwner = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getOwnerUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    this.allowSubscriptionType(SubscriptionType.GMS_PRO);
    return this;
  }

  allowGmsProGateManagers = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowUserTypes(getGateManagerUserTypes());
    this.allowUserTypes(getOwnerUserTypes());
    this.allowGmsProOwner();
    return this;
  };

  allowAdmin = () => {
    this.allowUserTypes(getAdminUserTypes());
    this.allowAccountType(AccountType.ADMIN);
    return this;
  }

  allowSupplierSuperAdmin = () => {
    this.allowUserTypes(getSuperAdminUserTypes());
    this.allowAccountType(AccountType.SUPPLIER);
    return this;
  }

  allowAllSubscriptionTypes = () => {
    this.allowSubscriptionType(SubscriptionType.MARKETPLACE_ONLY);
    this.allowGmsSubscriptionTypes();
    return this;
  }

  allowGmsSubscriptionTypes = () => {
    this.allowSubscriptionType(SubscriptionType.GMS_LITE);
    this.allowSubscriptionType(SubscriptionType.GMS_PRO);
    return this;
  }

}
